import styled from "styled-components";

export const StyledTablePmePrograma = styled.section`
width: 100%;
overflow: auto;


.hover {
    &:hover {
        cursor: pointer;
    }
}

.filterInput{
    whidth: 100%;
}

.card-menu-hide {
    background: black;
    color: #fff;
    margin: 1rem;
    font-size: 11px;
    display: none;
    width: 50%;
    padding: 5px;
    border-radius: 7px;
}

.timeline-menu-show {
    position: absolute;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.05);
    border: 1px solid #bebebe;
    border-radius: 11px;
    z-index: 1;
}
.default-button-red {
    max-width: 280px;
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.default-button {
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: white;
    color: #EE4B21;
    font-size: 0.8rem;
}

.page-title {
    font-size: 24px;
    font-weight: bold;
    margin: -20px 0 13px 0;
}

.card {
    background-color: #fff;
    border-radius: .25rem;
    min-width: 90%;
    margin-top: 1rem !important;
    margin: 0;

    & .border-wrapper {
        border: solid 1px #ccc;
        border-radius: .25rem;
        padding: 1rem;
    }
}

.timesheet {


@media only screen and (min-width: 1350px) {
    

        .table-container {
            width: 100%;
            overflow-y: auto;
            overflow-x: auto;
            height: calc(100vh - 430px);


            table {
                border-collapse: collapse;
                width: auto;
                table-layout: auto;
            }

            th,
            td {
            }

            th {
                background-color: #fff;
                position: sticky;
                top: 0;
            }
          }

}




    .table-scroll {
        overflow-x: scroll;
        overflow-y: scroll !important;
        width:100%;
        height:100%;
    }

    .table.table-bordered > thead > tr > th,
    table.table-bordered > tbody > tr > td {
        white-space: nowrap;
        border-top-style: solid;
        border-left-style: solid;
        border-right-style: solid;
    }

    .table-container {
        overflow-x: auto;
    }
    .table-container table {
        margin: 0;
    }

    .legend-value {
        color: green;
        font-weight: 1000;
    }

    .legend {
        color: green;
    }

    .table.table-bordered > thead > tr {
        box-shadow: inset 0 1px 0 #E8E8E8, inset 0 -1px 0 #E8E8E8;
    }

@media only screen and (max-width: 1550px) {

    .width-50 {
        width: 50px;
    }


    .width-30 {
        width: 30px;
    }

    .width-35 {
        width: 35px;
    }

    .width-40 {
        width: 40px;
    }

    .width-45 {
        width: 45px;
    }

    .width-50 {
        width: 50px;
    }

    .width-60 {
        width: 60px;
    }

    .width-70 {
        width: 70px;
    }

    .width-80 {
        width: 80px;
    }

    .width-90 {
        width: 90px;
    }

    .width-100{
        width: 100px;
    }

    .width-110 {
        width: 110px;
    }

     .width-120 {
        width: 120px;
    }

    .width-130 {
        width: 130px;
    }


    .width-116 {
        width: 116px;
    }


    .width-140 {
        width: 140px;
    }

    .width-150 {
        width: 148px;
    }


    .table.table-bordered > thead {
        background-color: #fff;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
    }

    table.table-bordered > tfoot {
        background-color: #fff;
        position: -webkit-sticky;
        position: sticky;
        bottom: 0;
    }

    table.table-bordered > tfoot > tr > td {
        white-space: nowrap;
        border-top-style: solid;
        border-left-style: solid;
        border-right-style: solid;
        font-size: 12px;
        text-align: right;
        font-weight: 1000;
    }


}

.header-items {
        a {
            padding: 0 3px;
            color: #cac6c6;

            &:hover {
                color: #c83e1b;
            }

            i {
                font-size: 17px;
                padding: 0 2px;
            }

            .possui-comentarios {
                color: #EE4B21;
            }
        }
    }



.revisaoCard{
    background: #f1626240 !important;
}

.esclarecimentoCard{
    background: #f3e8f3 !important;
}

.notificacaoCard{
    background: #f7cc4d61 !important;
}


.text-revisaoCard{
    color: #f1626240 !important;
}

.text-notificacaoCard{
    color: #f7cc4d61 !important;
}

}


.timesheet{
    margin-top: 0rem;
}


.collumResetBtn{
    width: 10ch !important;
}



.collumResetBtn {
    top: 150px;
    right: 30px;
    position: absolute;
    width: 3ch !important;
    padding: 0.10rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #EE4B21;

    &:hover {
       background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.td-font-7 {
    font-size: 0.7rem !important;
}   

/* O contêiner do elemento que terá o tooltip */
.has-tooltip {
  position: relative; /* Essencial para o posicionamento do tooltip */
  cursor: pointer;
}

/* Estilos da caixa do tooltip (::before) e da seta (::after) */
.has-tooltip::before,
.has-tooltip::after {
  /* Escondido por padrão */
  visibility: hidden;
  opacity: 0;
  pointer-events: none; /* Não interfere com o mouse */

  /* Transição suave para aparecer */
  transition: opacity 0.2s ease-in-out;
  
  position: absolute;
  z-index: 10; /* Garante que fique sobre outros elementos */
  left: 50%;
  transform: translateX(-50%);
}

/* A caixa de texto do tooltip */
.has-tooltip::before {
  content: attr(data-tooltip); /* Pega o texto do atributo data-tooltip */
  
  /* Posicionamento - acima do elemento */
  bottom: 125%; 
  
  /* Estilo visual */
  background-color: #212529; /* Cor escura, similar ao Bootstrap */
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  white-space: nowrap; /* Impede a quebra de linha */
}

/* A seta do tooltip */
.has-tooltip::after {
  content: '';
  
  /* Posicionamento - entre o elemento e a caixa de texto */
  bottom: 100%;
  
  /* Criação do triângulo com bordas */
  border-width: 5px;
  border-style: solid;
  border-color: #212529 transparent transparent transparent;
}

/* Mostra o tooltip ao passar o mouse */
.has-tooltip:hover::before,
.has-tooltip:hover::after {
  visibility: visible;
  opacity: 1;
}

`;
